import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { SEO, RelatedArticles } from 'components';
import { enableAnimations, getCloudinaryUrl } from 'config/helpers';
import { ArticleContent, Navigation } from './subcomponents';
import './SingleArticle.scss';

export class ArticleTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: '',
    };
  }

  componentDidMount() {
    enableAnimations();
    this.setState({ location: window.location.href });
  }

  render() {
    const { location } = this.state;
    const { post, postList, contributor, allArticles } = this.props;
    const { cover, title, settings } = post.frontmatter;
    const slug = settings.slug || post.fields.slug;

    return (
      <div className={'single-article'}>
        <SEO
          title={settings.metaTitle || title}
          description={settings.metaDescription}
          cover={getCloudinaryUrl(cover, 'f_auto,q_auto,w_400')}
          slug={slug}
          section="blog"
          canonical={settings.canonical}
          cloudinary
        />
        <ArticleContent
          windowLocation={location}
          data={post.frontmatter}
          contributor={contributor}
          allArticles={allArticles}
        />
        {!(isEmpty(allArticles) || isEmpty(settings.related)) && (
          <RelatedArticles
            id={'cs-related'}
            related={settings.related}
            allArticles={allArticles}
          />
        )}

        <Navigation currentSlug={slug} allPosts={postList} />
      </div>
    );
  }
}

ArticleTemplate.propTypes = {
  post: PropTypes.shape().isRequired,
  postList: PropTypes.array.isRequired,
  allArticles: PropTypes.object.isRequired,
  contributor: PropTypes.shape().isRequired,
};

export default ArticleTemplate;
